import React from "react"
import { ModificationOrderLines } from "../../../classes/order/ModificationOrderLines"
import { ModificationAddresses } from "../../../classes/order/OrderModificationAddresses"
import { Delivery } from "../../../classes/order/Delivery"
import { Refund } from "../../../classes/order/Refund"
import { Compensation } from "../../../classes/order/Compensation"
import { Cancellation } from "../../../classes/order/Cancellation"
import { Release } from "../../../classes/order/Release"
import { Order } from "lib/types/generated/graphql-types"
import { NoticeBanner } from "../../Ui/Messages/NoticeBanner"
import { NoticeWrapper } from "../../../views/Orders/OrderViews/ViewOrder.styled"
import { useNavigate } from "react-router-dom"
import { ReactComponent as SettingsIcon } from "images/icons/gear.svg"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"


type Props = {
  order: Order
}

const Notice = ({ order }: Props) => {

  const navigate = useNavigate()

  const modificationOrderLines = new ModificationOrderLines(order?.Modifications)
  const modificationsAddresses = new ModificationAddresses(order?.Modifications)
  const deliveries = new Delivery(order?.Deliveries)
  const refunds = new Refund(order?.Refunds)
  const compensations = new Compensation(order?.Compensations)
  const cancellations = new Cancellation(order?.Cancellations)
  const releases = new Release(order?.Releases)

  enum OPERATION_TYPE {
    DELIVERY = "Delivery",
    REFUND = "Refund",
    RELEASE = "Release",
    COMPENSATION = "Compensation",
    CANCELLATION = "Cancellation",
    MODIFICATION_ORDER_LINES = "Modification order lines",
    MODIFICATION_ADDRESSES = "Modification address"
  }

  const getPendingNotice = (type: OPERATION_TYPE) => {
    return (
      <NoticeBanner type="reminder">
        <NoticeWrapper>
          Pending {type}{" "}
          <WithAuth requiredGroups={PermissionGroups.orders.write}>
            <span onClick={() => navigate(`/orders/manage-order/${order?.id}`)}>Actions <SettingsIcon/></span>
          </WithAuth>
        </NoticeWrapper>
      </NoticeBanner>
    )
  }

  const getFailedNotice = (type: OPERATION_TYPE) => {
    return (
      <NoticeBanner type="important">
        <NoticeWrapper>
          Failed {type}{" "}
          <WithAuth requiredGroups={PermissionGroups.orders.write}>
            <span onClick={() => navigate(`/orders/manage-order/${order?.id}`)}>Actions <SettingsIcon/></span>
          </WithAuth>
        </NoticeWrapper>
      </NoticeBanner>
    )
  }

  const getNotCompletedNotice = (type: OPERATION_TYPE) => {
    if (type === OPERATION_TYPE.MODIFICATION_ADDRESSES)
      return (
        <NoticeBanner type="reminder">
          <NoticeWrapper>Not completed address update</NoticeWrapper>
        </NoticeBanner>
      )

    return (
      <NoticeBanner type="reminder">
        <NoticeWrapper>
          Not completed {type}
          <WithAuth requiredGroups={PermissionGroups.orders.write}>
            <span onClick={() => navigate(`/orders/manage-order/${order?.id}`)}>Actions <SettingsIcon/></span>
          </WithAuth>
        </NoticeWrapper>
      </NoticeBanner>
    )
  }

  return (
    <div>
      {refunds.onGoing() ? getNotCompletedNotice(OPERATION_TYPE.REFUND) : <></>}
      {deliveries.onGoing() ? getNotCompletedNotice(OPERATION_TYPE.DELIVERY) : <></>}
      {compensations.onGoing() ? getNotCompletedNotice(OPERATION_TYPE.COMPENSATION) : <></>}
      {cancellations.onGoing() ? getNotCompletedNotice(OPERATION_TYPE.CANCELLATION) : <></>}
      {modificationOrderLines.onGoing() ? (
        getNotCompletedNotice(OPERATION_TYPE.MODIFICATION_ORDER_LINES)
      ) : (
        <></>
      )}
      {modificationsAddresses.onGoing() ? (
        getNotCompletedNotice(OPERATION_TYPE.MODIFICATION_ADDRESSES)
      ) : (
        <></>
      )}
      {releases.onGoing() ? getNotCompletedNotice(OPERATION_TYPE.RELEASE) : <></>}

      {refunds.pending() ? getPendingNotice(OPERATION_TYPE.REFUND) : <></>}
      {deliveries.pending() ? getPendingNotice(OPERATION_TYPE.DELIVERY) : <></>}
      {compensations.pending() ? getPendingNotice(OPERATION_TYPE.COMPENSATION) : <></>}
      {cancellations.pending() ? getPendingNotice(OPERATION_TYPE.CANCELLATION) : <></>}
      {modificationOrderLines.pending() ? (
        getPendingNotice(OPERATION_TYPE.MODIFICATION_ORDER_LINES)
      ) : (
        <></>
      )}
      {releases.pending() ? getPendingNotice(OPERATION_TYPE.RELEASE) : <></>}

      {refunds.failed() ? getFailedNotice(OPERATION_TYPE.REFUND) : <></>}
      {deliveries.failed() ? getFailedNotice(OPERATION_TYPE.DELIVERY) : <></>}
      {compensations.failed() ? getFailedNotice(OPERATION_TYPE.COMPENSATION) : <></>}
      {cancellations.failed() ? getFailedNotice(OPERATION_TYPE.CANCELLATION) : <></>}
      {modificationOrderLines.failed() ? (
        getFailedNotice(OPERATION_TYPE.MODIFICATION_ORDER_LINES)
      ) : (
        <></>
      )}
      {releases.failed() ? getFailedNotice(OPERATION_TYPE.RELEASE) : <></>}
    </div>
  )
}

export default Notice
